"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHTMLAttr = exports.getHTMLAttrs = void 0;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var booleanAttrs = ["disabled", "hidden", "selected"];
var isHTMLAttr = function isHTMLAttr(attribute, interfaces, noFilter) {
  return (interfaces ? interfaces : [Element]).reduce(function (acc, curr) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(Object.keys(curr.prototype)));
  }, []).filter(function (attr) {
    return noFilter || !["id", "class"].includes(attr) && !attr.startsWith("aria");
  }) // filter attributes that shouldn't be passed through the dom
  .includes(attribute);
};
/**
 * CAUTION: This will only give you HTML attributes that are specified ON THE DOM ELEMENT.
 * Attributes that are set via prop will not be included.
 */
exports.isHTMLAttr = isHTMLAttr;
var getHTMLAttrs = function getHTMLAttrs(attrs, interfaces, options) {
  return (Array.isArray(attrs) ? attrs : Array.from(attrs)).filter(function (_ref) {
    var name = _ref.name;
    if (options && options.omit) {
      return !options.omit.includes(name);
    }
    return isHTMLAttr(name, interfaces);
  }).reduce(function (acc, curr) {
    return Object.assign(Object.assign({}, acc), _defineProperty({}, curr.name, curr.value === "" && booleanAttrs.includes(curr.name) ? true : curr.value));
  }, {});
};
exports.getHTMLAttrs = getHTMLAttrs;